define(function(require) {
	const tpl =  require('civicsViews/favoriteContacts/templates/t_lov_favorite.hbs');
    const ModalRegion = require('civicsUtils/modal_region');
	const SelectFavoritesView = require('civicsViews/favoriteContacts/v_lov_select_favorite');
	const AddFavoriteContactsView = require('civicsViews/favoriteContacts/add_favorite_modal/v_cpv_add_favorites_modal');
	const dynamic_form_view = require('civicsViews/dynamic_form/v_lov_dynamic_form');
	const Utils = require('civicsUtils/general_utilities');

	return Marionette.LayoutView.extend({
		template: tpl,
		regions: {
            favoritesItemRegion:'.favorite-items-region',
            modalRegion: {
                regionClass: ModalRegion,
                selector: 'body .rhythm-modals',
              },
             confirmationModalRegion: {
                regionClass: ModalRegion,
                selector: 'body .rhythm-modals',
              },
		},
		ui: {
            nextButton: '.select-favorites-next',
            cancelButton: '.cancel-select-favorites',


		},
		events: {
			'click @ui.nextButton': 'selectNextButtonClicked',
			'click @ui.cancelButton': 'cancelClicked',

		},
		childEvents: {
            'call-contact:added':'callContactAdd',
            'call-invite:added':'callInviteAdd',
            'change-state:nextBtn':'disableButton',
            'showCancel': 'showCancelConfirmation'
		},
		initialize: function(options) {
            this.config = options.config;
            this.controller = options.controller;
            this.collection = options.collection;
            this.selectedFavorites = new Backbone.Collection();
            this.additionalCapacityTypes = options.additionalCapacityTypes;
            this.applicantTypes = options.applicantTypes;
            this.isInviteProcess = options.isInviteProcess;
            this.submitApplCollection = options.submitApplCollection;
            this.isPortalInstrument = this.config.dataForReview ? true : false;
            this.skipAddFavoritesModal = options.config.showApplicantType == false && options.config.showCapacity == false;
		},

		onShow: function() {
            this.showSelectFavoritesView();
            this.config.countRecancel = null;

		},
        disableButton: function(childView, disable){
            if(disable){
                this.ui.nextButton.addClass("disabled");
            }else{
                this.ui.nextButton.removeClass("disabled");
            }
        },
		selectNextButtonClicked: function (childView, fromCancel) {
            const addFavoritesView = this.createAddFavoritesView();
            if (fromCancel) {
                const modalRegion = this.modalRegion;
                this.reshowModalView(modalRegion, addFavoritesView);
                //rebind the events
                this.listenTo(addFavoritesView, 'showCancel', this.showCancelConfirmation);
                this.listenTo(addFavoritesView, 'call-contact:added', this.callContactAdd);
                this.listenTo(addFavoritesView, 'invitation:added', this.callInviteAdd);
            } else {
                if(this.skipAddFavoritesModal){
                    this.addFavorites();
                }else{
                    this.modalRegion.show(addFavoritesView);
                }
            }

		},
        addFavorites: function (){
			let tempApplicantData = [];
			tempApplicantData  = this.controller.processContactsForSubmission(this.selectedFavorites, this.isPortalInstrument, this.isInviteProcess, this.config)
			
			if(this.isInviteProcess){
				this.sendInvites(tempApplicantData);
			}else{
				this.addAsApplicant(tempApplicantData);
			}


        },
        sendInvites : function(data){
			let favoriteData = data;
			let isBulkUpdate = favoriteData.length > 1 ? true : false
            const listView = this.favoritesView.getChildView('listRegion');
			if(this.isPortalInstrument){ //means instrument record is being created in add instrument portlet
				const uniqueApplicants = this.controller.getValidInvites(favoriteData, this.config.submitInvitationsList, this.config, listView.children, this.isPortalInstrument);
				if (uniqueApplicants.length !== favoriteData.length) {
					// All were duplicates — no need to call API
					return;
				}

				this.callInviteAdd(favoriteData);
                this.triggerMethod('cancel:clicked');
			}else{
				const uniqueApplicants = this.controller.getValidApplicants(favoriteData, this.config.addApplEditCollection, this.config, listView.children);
				if (uniqueApplicants.length !== favoriteData.length) {
					// All were duplicates — no need to call API
					return;
				}

				this.sendInvitesToFavoritesPromise = this.controller.sendInvitesToFavorites(favoriteData);
				this.sendInvitesToFavoritesPromise.done(() => {
					this.triggerMethod('cancel:clicked'); //close the add applicant modal
					if(isBulkUpdate){
						Utils.civicsToastPop( i18n.t('CIVICS.COMMON_INVITE_APPLICANT.BULK_INVITE_APPLICANT_UPDATED_SUCCESS'), "success");
					}else{
						Utils.civicsToastPop( i18n.t('CIVICS.COMMON_INVITE_APPLICANT.SINGLE_INVITE_APPLICANT_UPDATED_SUCCESS'), "success");
					}
					window.location.reload();
				}).fail((response)=>{
					ViewManager.errorToWindow(response);
				});	
			}

		},

		addAsApplicant : function(data){
			let applicantData = data;
			let isBulkUpdate = applicantData.length > 1 ? true: false;
            const listView = this.favoritesView.getChildView('listRegion');
			if(this.isPortalInstrument){ //means instrument record is being created in add instrument portlet
				const uniqueApplicants = this.controller.getValidApplicants(applicantData, this.submitApplCollection, this.config, listView.children, this.isPortalInstrument);
				if (uniqueApplicants.length !== applicantData.length) {
					// All were duplicates — no need to call API
					return;
				}

				this.callContactAdd(applicantData);
			}else{
			const uniqueApplicants = this.controller.getValidApplicants(applicantData, this.config.addApplEditCollection, this.config, listView.children,);
			if (uniqueApplicants.length !== applicantData.length) {
				// All were duplicates — no need to call API
				return;
			}
				this.addAsApplicantPromise = this.controller.addFavoritesAsApplicants(applicantData);
				this.addAsApplicantPromise.done(() => {
					this.triggerMethod('cancel:clicked'); //close the invite applicant modal
					if(isBulkUpdate){
						Utils.civicsToastPop( i18n.t('CIVICS.COMMON_ADD_APPLICANT.BULK_ADDITIONAL_APPLICANT_UPDATED_SUCCESS'), "success");
					}else{
						Utils.civicsToastPop( i18n.t('CIVICS.COMMON_ADD_APPLICANT.SINGLE_ADDITIONAL_APPLICANT_UPDATED_SUCCESS'), "success");
					}
					window.location.reload();
				}).fail((response)=>{
					ViewManager.errorToWindow(response);
				});			
				
			}
		},

        createAddFavoritesView: function() {
            return new AddFavoriteContactsView({
                config: this.config,
                controller: this.controller,
                //we need to pass in the cloned collection so that when we remove from selected, we are not removing the actual favorite
                collection: new Backbone.Collection(this.selectedFavorites.map(m => m.clone())),
                modalRegion: this.getRegion('modalRegion'),
                additionalCapacityTypes: this.additionalCapacityTypes,
                applicantTypes: this.applicantTypes,
                isInviteProcess: this.isInviteProcess,
                submitApplCollection: this.submitApplCollection
            });
        },
		callContactAdd: function(_viewOrData, data) {
            data = data !== undefined ? data : _viewOrData;
            this.triggerMethod('contact:added', data);
		},
		callInviteAdd: function(_viewOrData, data) {
            data = data !== undefined ? data : _viewOrData;
            this.triggerMethod('invitation:added', data);
		},
        reshowModalView: function(region, view) {
            // prevent destroy for reused views
            if (this.config) {
                this.config.preventDestroy = true;
            }

            region.closeModalPromise = $.Deferred();
            region.hideModal();

            //wait for the modal to fully close before reshowing a new modal
            $.when(region.closeModalPromise).done(() => {
                region.show(view);
                region.showModal();
                this.config.preventDestroy = null; //reset preventDestroy (important!!)

            });
        },
       showCancelConfirmation: function (childView, reCancel) {
			var options = {
				elements: this.getCancelConfirmationElements(),
				saveCallback: this.closeModal.bind(this),
				skipValidation: true,
				titleText: i18n.t('CIVICS.FAVORITES.DIALOG.CANCEL_CONFIRMATION_TITLE'),
				saveText: i18n.t('CIVICS.COMMON.YES'),
			}
			this.modalView = new dynamic_form_view({
				cancelText: i18n.t('CIVICS.COMMON.NO'),
				isModal: true,
				formClass: 'confirmation-cancel-modal',
				closeCallback: this.closeModal.bind(this),
				cancelCallback: this.selectNextButtonClicked.bind(this, null, true),

				...options
			  });
              //reshowing cancel if cancel is clicked.
              if(reCancel == true){
                this.reshowModalView(this.confirmationModalRegion, this.modalView);
              }else{
                this.confirmationModalRegion.show(this.modalView);
                this.confirmationModalRegion.showModal();
              }
		},
		onRemoveSelectedItem: function (childView) {
			this.collection.remove(childView);
		},
        getCancelConfirmationElements: function (isAdding) {
			var deleteModalElements = [];
			deleteModalElements.push({
				text: i18n.t('CIVICS.FAVORITES.DIALOG.CANCEL_CONFIRMATION'),
				classes: 'confirmation-cancel',
				type: 'label',
				isVisible: true,
			});

			return deleteModalElements;
		},
        closeModal:function(){
			if (this.modalRegion) {
			  this.modalRegion.hideModal();
			}
		  },

        showSelectFavoritesView: function (){
            this.favoritesView = new SelectFavoritesView({
				config: this.config,
				collection: this.collection,
                controller: this.controller,
                selectedFavorites: this.selectedFavorites,
                isInviteProcess: this.isInviteProcess
            });
            this.favoritesItemRegion.show(this.favoritesView);
        },
        cancelClicked: function(){
            this.triggerMethod('cancel:clicked');
        },
		templateHelpers: function(){
			return {
                nextButtonText: this.skipAddFavoritesModal ? i18n.t('CIVICS.FAVORITES.DIALOG.ADD') : i18n.t('CIVICS.COMMON.NEXT')
            }
		}
	});
});
